// src/pages/compan-admin/CompanyAdminLayout.tsx
import { useAuth } from '../../features/auth/AuthContext';
import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

const linkBase = 'px-3 py-1.5 text-xs rounded-full border transition-colors';
const linkActive = 'bg-sky-600 text-white border-sky-600';
const linkInactive = 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50';

const CompanyAdminLayout: React.FC = () => {
    const { me, logout } = useAuth();
    const nav = useNavigate();

    return (
        <div className="p-6 space-y-4">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-xl font-bold text-gray-900">Company Admin</h1>
                    <p className="text-xs text-gray-500 mt-1">회사 정보, 사용자, 프로젝트를 관리합니다.</p>
                </div>
                {/* ⬇ 오른쪽: 계정 아이콘 영역 */}
                <div className="flex items-center gap-2">
                    {me ? (
                        <>
                            {!me.isGuestOnlyUser && (
                                <button
                                    className="inline-flex items-center rounded-xl border px-3 py-2 text-sm hover:bg-gray-50"
                                    title="비밀번호 변경"
                                    onClick={() => nav('/account/security')}
                                >
                                    <span className="mr-2">🔒</span> 비밀번호 변경
                                </button>
                            )}
                            {/* 사용자 전환/프로필 (간단 표시) */}
                            <button
                                className="inline-flex items-center rounded-xl border px-3 py-2 text-sm //hover:bg-gray-50"
                                title="사용자 정보"
                                // onClick={() => nav('/projects/overview')}
                                disabled
                            >
                                <span className="mr-2">👤</span>
                                {me.name ?? '사용자'}
                            </button>
                            {/* 로그아웃 */}
                            <button
                                className="inline-flex items-center rounded-xl border px-3 py-2 text-sm hover:bg-gray-50"
                                title="로그아웃"
                                onClick={() => {
                                    if (typeof logout === 'function') {
                                        logout();
                                    }
                                    nav('/login?logged_out=1', { replace: true });
                                }}
                            >
                                <span className="mr-2">🚪</span> 로그아웃
                            </button>
                        </>
                    ) : (
                        <button
                            className="inline-flex items-center rounded-xl border px-3 py-2 text-sm hover:bg-gray-50"
                            title="로그인"
                            onClick={() => nav('/login')}
                        >
                            <span className="mr-2">🔑</span> 로그인
                        </button>
                    )}
                </div>
            </div>
            <div className="flex items-center gap-2 text-xs">
                <NavLink
                    to="profile"
                    className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                    end
                >
                    Profile
                </NavLink>
                <NavLink
                    to="partners"
                    className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                >
                    Partners(외부)
                </NavLink>
                <NavLink to="users" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}>
                    Users(내부)
                </NavLink>
                <NavLink
                    to="projects"
                    className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                >
                    Projects
                </NavLink>
            </div>

            <div className="rounded-2xl border bg-white shadow-sm">
                <Outlet />
            </div>
        </div>
    );
};

export default CompanyAdminLayout;
